export const EVENTS = {
  OX_INCENTIVEMODEL_SAVE: 'ox_incentivemodel_save',
  OX_INCENTIVEMODEL_DEACTIVATE: 'ox_incentivemodel_deactivate',
  PX_INCENTIVEMODEL_ADD: 'px_incentivemodel_add',
  PX_INCENTIVEMODEL_ADD2: 'px_incentivemodel_add2',
  PX_INCENTIVEMODEL_CANCEL: 'px_incentivemodel_cancel',
  PX_INCENTIVEMODEL_SAVE: 'px_incentivemodel_save',
  PX_INCENTIVEMODEL_DEACTIVATE: 'px_incentivemodel_deactivate',
  PX_INCENTIVEMODEL_DELETE: 'px_incentivemodel_delete',
  CREATE_PANEL_START: 'create_panel_start',
  CREATE_PANEL_SUBMIT: 'create_panel_submit',
  PANEL_LIVE: 'panel_live',
  PANEL_MAINTENANCE: 'panel_maintenance',
  PANEL_LIVE2: 'panel_live2',
  PANEL_MAINTENANCE2: 'panel_maintenance2',
  TOGGLE_SELFREGISTRATION_ON: 'toggle_selfregistration_on',
  TOGGLE_SELFREGISTRATION_OFF: 'toggle_selfregistration_off',
  TOGGLE_INCENTIVEREDEMPTION_ON: 'toggle_incentiveredemption_on',
  TOGGLE_INCENTIVEREDEMPTION_OFF: 'toggle_incentiveredemption_off',
  TOGGLE_CXINTEGRATION_ON: 'toggle_cxintegration_on',
  TOGGLE_CXINTEGRATION_OFF: 'toggle_cxintegration_off',
  TOGGLE_OFFERWALL_SIDEBAR_ON: 'toggle_offerwall_sidebar_on',
  TOGGLE_OFFERWALL_SIDEBAR_OFF: 'toggle_offerwall_sidebar_off',
  TOGGLE_PRE_SURVEY_MODAL_ON: 'toggle_pre_survey_modal_on',
  TOGGLE_PRE_SURVEY_MODAL_OFF: 'toggle_pre_survey_modal_off',
  ACTIVATION_EMAIL_ON: 'activation_email_on',
  ACTIVATION_EMAIL_OFF: 'activation_email_off',
  PAYMENT_ADD: 'payment_add',
  CAMPAIGN_CREATE: 'campaign_create',
  CAMPAIGN_SAVE: 'campaign_save',
  CAMPAIGN_DELETE: 'campaign_delete',
  PAYMENT_CREATE: 'payment_create',
  PAYMENT_SUBMIT: 'payment_submit',
  PAYMENT_SAVE: 'payment_save',
  VOUCHER_CODE_UPLOADED: 'voucher_code_uploaded',
  BAN_PANELIST_START: 'ban_panelist_start',
  BAN_PANELIST_SUBMIT: 'ban_panelist_submit',
  CLOSE_PANELIST_START: 'close_panelist_start',
  CLOSE_PANELIST_SUBMIT: 'close_panelist_submit',
  BALANCE_ADJUSTMENT_START: 'balance_adjustment_start',
  BALANCE_ADJUSTMENT_CREDIT: 'balance_adjustment_credit',
  BALANCE_ADJUSTMENT_DEBIT: 'balance_adjustment_debit',
  BALANCE_ADJUSTMENT_SUBMIT: 'balance_adjustment_submit',
  PANELISTID_COPY: 'panelistid_copy',
  SUPPORT_TABLES_VIEWMORE: 'support_tables_viewmore',
  BULK_BANNING_UPLOADS: 'bulk_banning_uploads',
  BAN_RADIOBUTTON: 'ban_radiobutton',
  UNBAN_RADIOBUTTON: 'unban_radiobutton',
  BULK_BANNING_SUBMIT: 'bulk_banning_submit',
  BULK_BANNING_CANCEL: 'bulk_banning_cancel',
  BULK_BALANCE_UPLOADS: 'bulk_balance_uploads',
  BULK_BALANCE_SUBMIT: 'bulk_balance_submit',
  BULK_BALANCE_CANCEL: 'bulk_balance_cancel',
  TRANSLATION_CREATED_START: 'translation_created_start',
  TRANSLATION_CREATED_SUBMIT: 'translation_created_submit',
  TRANSLATIONS_FILES_UPLOADED: 'translations_files_uploaded',
  TRANSLATIONS_FILES_DOWNLOADED: 'translations_files_downloaded',
  MODIFIED_KEYS_DOWNLOADED: 'modified_keys_downloaded',
  BULK_TRANSLATIONS_UPDATE_START: 'bulk_translations_update_start',
  BULK_TRANSLASTIONS_UPDATE_SUBMIT: 'bulk_translations_update_submit',
  REPORTING_CHARTS_DOWNLOADED: 'reporting_charts_downloaded',
  DATE_FILTER_DAILY: 'date_filter_daily',
  DATE_FILTER_WEEKLY: 'date_filter_weekly',
  DATE_FILTER_MONTHLY: 'date_filter_monthly',
} as const;
